import { useState, useEffect } from 'react';
import useIsMounted from './useIsMounted';

const useDelayLoading = (delayMs: number = 0.5) => {
    const [completed, setCompleted] = useState(false);

    const isMounted = useIsMounted();

    useEffect(() => {
        const timeout = setTimeout(() => {
            isMounted() && setCompleted(true);
        }, delayMs * 1000);

        return () => clearTimeout(timeout);
    }, [delayMs, isMounted]);

    return completed;
};

export default useDelayLoading;
